import { render, staticRenderFns } from "./consultationSetting.vue?vue&type=template&id=4aa7451a&scoped=true"
import script from "./consultationSetting.vue?vue&type=script&lang=js"
export * from "./consultationSetting.vue?vue&type=script&lang=js"
import style0 from "./consultationSetting.vue?vue&type=style&index=0&id=4aa7451a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aa7451a",
  null
  
)

export default component.exports